import requests from './httpService';
const TeacherNotesService = {
  getAllTeacherNotes(body = {}) {
    return requests.post('/teachernotes/list', body);
  },
  getNotesByStudent(body) {
    return requests.post('/teachernotes/list', body);
  },
  getStudentsForNotes(body) {
    return requests.post('/teachernotes/students', body);
  },
  creteTeacherNotes(body){
    return requests.post('/teachernotes/add',body); 
  },
  deleteTeacherNotes(body){
    return requests.delete(`/teachernotes/${body._id}`); 
  },
  findTeacherNotesList(body){
    return requests.post(`/teachernotes/find`,body); 
  },
  upadeTeacherNotes(body) {
    return requests.patch(`/teachernotes/update/${body._id}`,body); 
  },
 
};
export default TeacherNotesService;
